export default __webpack_public_path__ + "static/media/nurseKelley.1b6ea586.png";